<template>
  <div class="card card-shadow card-rounded border-0 mb-4" v-if="showFullDetailsForWrittenOff || loan.subStatus !== 'WRITTEN_OFF'" id="defaulted-loan">
    <LoanDefaultedMessage :status="loan.subStatus"></LoanDefaultedMessage>
    <div class="card-body">
      <div class="row">
        <div class="col form-group" id="default-loan-remaining-amount">
          <div class="small text-warning">{{$t('LoanDetailsPage.finalDueAmount')}}</div>
          <div class="text-amount text-muted">{{ $n(loan.remainingAmount, 'currency') }}</div>
        </div>
      </div>
      <LoanCardActions :loan="loan" :showCalculator="showCalculator" />
    </div>
  </div>
</template>

<script>
import LoanDefaultedMessage from '@shared/components/loan/details/LoanDefaultedMessage'
import LoanCardActions from '@shared/components/loan/details/LoanCardActions'

export default {
  name: 'DefaultLoanCard',
  props: ['loan', 'showFullDetailsForWrittenOff'],
  components: {
    LoanCardActions,
    LoanDefaultedMessage
  },
  computed: {
    showCalculator() {
      return !this.$configuration.newCoreEnabled && this.loan.subStatus === 'RESTRUCTURED'
    }
  }
}
</script>
